{
  "name": "frontend",
  "lockfileVersion": 3,
  "requires": true,
  "packages": {}
}
